import ShopAddressSettingsSection from './shop-address-settings-section';

export default ShopAddressSettingsSection;
